<div class="page-content" fxLayout="row" fxLayoutAlign="center center" fxFlexFill>
  <div>
    <mat-card fxFlex="100%" class="mat-elevation-z24">
      <mat-card-header>
        <mat-card-title>{{'login.Login' | translate}}</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <app-login-control [isModal]="false" (enterKeyPress)="loginControl.login()"></app-login-control>
      </mat-card-content>
      <mat-card-actions>
        <button mat-raised-button color="primary" (click)="loginControl.login()">
          {{'login.Login' | translate | uppercase}}
        </button>
      </mat-card-actions>
    </mat-card>
  </div>
</div>
